export default defineNuxtRouteMiddleware((to, from) => {
  // if (to.params.id === '1') {
  //   return abortNavigation()
  // }
  // // In a real app you would probably not redirect every route to `/`
  // // however it is important to check `to.path` before redirecting or you
  // // might get an infinite redirect loop

  if (to.path == '' || to.path == '/') {
    return navigateTo('/fa/home')
  }

  var regex = /^\/[a-zA-Z]{2}\/?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.endsWith("/") ? to.path.slice(0, -1) : to.path}/home`;

    return navigateTo(newPath, { redirectCode: 301 });
  }

  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace(/\/$/, '')}/1/translate`;

    return navigateTo(newPath, { redirectCode: 301 });
  }

  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace(/\/$/, '')}/translate`;

    return navigateTo(newPath, { redirectCode: 301 });
  }
  
  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/mobileanalysis?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace("/mobileanalysis", '/analysis')}`;

    return navigateTo(newPath, { redirectCode: 301 });
  }

  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/related-hadith?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace("/related-hadith", '/related_hadith')}`;

    return navigateTo(newPath, { redirectCode: 301 });
  }
  
  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/related-vocabulary?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace("/related-vocabulary", '/related_vocabulary')}`;

    return navigateTo(newPath, { redirectCode: 301 });
  }
  
  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/related-propername?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace("/related-propername", '/related_propername')}`;

    return navigateTo(newPath, { redirectCode: 301 });
  }

  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/related-subject?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace("/related-subject", '/related_subject')}`;

    return navigateTo(newPath, { redirectCode: 301 });
  }

  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/related-ayah?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace("/related-ayah", '/related_ayah')}`;

    return navigateTo(newPath, { redirectCode: 301 });
  }

  regex = /^\/[a-zA-Z]{2}\/ayah\/\d+\/\d+\/related-library?$/;
  if (regex.test(to.path)) {
    const newPath = `${to.path.replace("/related-library", '/related_library')}`;

    return navigateTo(newPath, { redirectCode: 301 });
  }
})